export const websiteSections = [
  { id: 'contacts', label: 'Name and contacts', description: 'Identity and contact details' },
  { id: 'social', label: 'Social links', description: 'Labels, URLs and handles' },
  { id: 'menu', label: 'Menu and footer', description: 'Navigation and interface copy' },
  { id: 'images', label: 'Logo and images', description: 'Logo, icon and sharing image' },
  { id: 'cta', label: 'Global call to action', description: 'Label, destination and style' },
] as const;

export type SettingsSection = (typeof websiteSections)[number]['id'] | 'mac';
export type SettingsOutletContext = { section: SettingsSection | null };

export function readSettingsSection(value: string | null): SettingsSection | null {
  return value === 'mac' || websiteSections.some((section) => section.id === value)
    ? (value as SettingsSection)
    : null;
}

export function settingsSectionSearch(search: string, section: SettingsSection | null) {
  const params = new URLSearchParams(search);
  if (section) params.set('section', section);
  else params.delete('section');
  const next = params.toString();
  return next ? `?${next}` : '';
}
